<template>
  <div class="container h-100" v-loading="loading">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="base-screen">
        <b-card class="form-screen">
          <div class="text-center">
            <img src="../assets/styles/img/logo-large.svg" alt="Image placeholder" class="logo-img" />
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <p class="contact-text">{{lang.label.registerText}}</p>
              <b-card class="contact-detail width-wrap">
                <h4 class="text mb-3">{{lang.label.contactDetail}}</h4>
                <p class="secondary-text mb-1">+27 4564814</p>
                <p class="secondary-text mb-0">help@easyscript.com</p>
              </b-card>
              <div class="mtop">
                <b-btn type="submit" variant="primary" class="w-100">{{lang.label.buttons.backLogin}}</b-btn>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters({
      login: "login",
      loading: "loading",
    }),
    dateFrom(){
      return this.models.dateFrom;
    },
    dateTo(){
      return this.models.dateTo;
    }
  },
  data() {
    return {
      lang: this.$lang.register,
      models: {
        mobileNumber: ""
      }
    };
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {}
  }
};
</script>
